<template>
  <div class="c-seo-rules">
    <div class="c-seo-rules__nav">
      <app-tabs
        variant="pills"
        label="SEO rules sections"
        :tabs="seoTabs"
        :value="selectedTab.key"
        @input="changeActiveTab"
      />
    </div>

    <component
      :is="selectedTab.component"
      :key="selectedTab.key"
      :website="website"
    />
  </div>
</template>

<script>
import ContentEditComponent from './sub-pages/content-edit/index';
import BulkDataComponent from './sub-pages/bulk-data/index';
import TemplatesComponent from './sub-pages/templates/index';
import RedirectionsComponent from './sub-pages/redirections/index';
import RobotsComponent from './sub-pages/robots/index';
import CasinoCategoriesComponent from './sub-pages/casino-categories/index';
import CrossDomainHreflangComponent from './sub-pages/cross-domain-hreflang/index';
import HistoryLogComponent from './sub-pages/history-log/index';
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";
import {PERMISSION_NAMES} from "@/const/online-permissions";
import AppTabs from "@/shared/app-tabs/AppTabs";

export default {
  name: "SeoRules",

  components: {
    ContentEditComponent,
    BulkDataComponent,
    TemplatesComponent,
    RedirectionsComponent,
    RobotsComponent,
    CasinoCategoriesComponent,
    CrossDomainHreflangComponent,
    HistoryLogComponent,
    AppTabs,
  },

  mixins: [onlinePermissionsMixin],

  props: {
    website: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      permissionName: `${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES.key}`,
      historyLogPermission: `${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES_HISTORY.key}`,

      selectedTab: { label: 'Content Edit', component: 'ContentEditComponent', key: 'content-edit' },
      seoTabs: [
        { label: 'Content Edit', component: 'ContentEditComponent', key: 'content-edit' },
        { label: 'Casino Categories', component: 'CasinoCategoriesComponent', key: 'casino-categories' },
        { label: 'Bulk Data', component: 'BulkDataComponent', key: 'bulk-data' },
        { label: 'Templates', component: 'TemplatesComponent', key: 'templates' },
        { label: 'Cross Domain', component: 'CrossDomainHreflangComponent', key: 'cross-domain' },
        { label: 'Redirections', component: 'RedirectionsComponent', key: 'redirections', disabled: true },
        { label: 'Robots', component: 'RobotsComponent', key: 'robots', disabled: true },
      ]
    };
  },

  created() {
    if(this.canRead(this.historyLogPermission)) {
      this.seoTabs.push({ label: 'History Log', component: 'HistoryLogComponent', key: 'history-log' });
    } 
    this.seoTabs.map(tab => {
      if (tab.key === 'bulk-data') {
        tab.disabled = !this.canWrite(`${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES.key}`)
      }

      return tab;
    })
  },

  methods: {
    changeActiveTab(key) {
      this.selectedTab = this.seoTabs.find(tab => tab.key === key);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-seo-rules {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.c-seo-rules__nav {
  padding-bottom: 16px;
}
</style>
